export class AddCommentInput {
  leadId?: string;
  comments?: string;
}
